var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tooltip",class:_vm.cssClass,attrs:{"id":"text"},on:{"click":_vm.copy}},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('span',{staticClass:"tooltip-text"},[_vm._v("Click to copy")])])}
var staticRenderFns = []

export { render, staticRenderFns }